import { useLogo } from "@/contexts/LogoContext";
import { FlaskConical } from "lucide-react";

export const AppLogo = ({ size = "default", showText = true, className = "" }) => {
  const { logo, loading } = useLogo();
  
  const sizeClasses = {
    small: { logo: "h-8", text: "text-base", maxH: "32px" },
    default: { logo: "h-9", text: "text-lg", maxH: "36px" },
    large: { logo: "h-12", text: "text-2xl", maxH: "48px" }
  };
  
  const { logo: logoHeight, text: textSize, maxH } = sizeClasses[size] || sizeClasses.default;
  
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {loading ? (
        <div className={`${logoHeight} w-12 rounded bg-muted animate-pulse`} />
      ) : logo ? (
        <img 
          src={logo} 
          alt="LabStack" 
          className={`${logoHeight} w-auto object-contain`}
          style={{ maxHeight: maxH }}
        />
      ) : (
        <FlaskConical 
          className={`${logoHeight} w-auto text-primary`} 
          strokeWidth={1.5} 
        />
      )}
      {showText && (
        <span className={`font-heading font-bold ${textSize}`}>
          LabStack
        </span>
      )}
    </div>
  );
};

export default AppLogo;
